// extracted by mini-css-extract-plugin
export var categories = "fn_lX";
export var footerTop = "fn_lW";
export var footnote = "fn_cS";
export var footnoteContainer = "fn_hY";
export var subscriptionContainer = "fn_lY";
export var wrapper = "fn_ch";